<template>
  <VRow
    no-gutters
    class="d-flex justify-center align-center"
    style="position: fixed; top: 40%; left: 50%; transform: translate(-50% , -50%)"
  >
    <VCol cols="12" class="text-center">
      <VProgressCircular
        indeterminate color="blue"
        :size="size"
        :width="width"
      />
    </VCol>
  </VRow>
</template>

<script>
export default {
  name: 'AppPreloader',
  props: {
    size: {
      type: Number,
      default: 50,
    },
    width: {
      type: Number,
      default: 3,
    },
  },
};
</script>
